import script from "./FloatChatWindow.vue?vue&type=script&setup=true&lang=ts"
export * from "./FloatChatWindow.vue?vue&type=script&setup=true&lang=ts"

import "./FloatChatWindow.vue?vue&type=style&index=0&id=7296ca1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7296ca1a"]])

export default __exports__